module.exports = __webpack_public_path__ + "img/176.0aaf18ff.jpg";